const measurementUnitEn = {
	measurementUnitTable: 'Measurement Unit',
	measurementUnitEditForm: 'Measurement Unit',
	name: 'Name',
	created: 'Created',
	updated: 'Updated'
};

export default measurementUnitEn;
